import React from 'react'

const AdsBanner = () => {
  return (
    <>
    <section className='banner aads_banner'>
        <figure className='banner_figure aads_banner_figure'>
            <img src={require('../../ImagesComponents/bannerImg/ads_banner.jpg')} width="100%" alt='ads-banner' />
            <figcaption className='banner_caption aads_banner_caption'>
                <div className='container'>
                    <h1>Enhancing Business Visibility with Local Services Ads and Google Guarantee Program</h1>
                    <p><span>Caressa Losier</span>    <span>Categories: Pay Per Click</span>    <span>Reading Time: 5 minutes</span></p>
                </div>
            </figcaption>
        </figure>
    </section>
    
    </>
  )
}

export default AdsBanner